.action-buttons-row {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.button-container {
  margin-left: 0.25rem;
}

.action-button {
  margin: 0.15rem;
  display: flex;
  align-items: center;
  justify-content: center;

  padding: 0;
  border: 0;
  background: transparent;

  color: black;
  cursor: pointer;

  &__icon {
    font-size: 1.2rem;
  }

  &:disabled {
    color: var(--color-gray-100);
    cursor: not-allowed;
  }
}

.success-tooltip {
  background: var(--color-app-state--ok-200);
  border-color: var(--color-app-state--ok-400);
  color: var(--color-app-state--ok-900);

  font-size: 0.7rem;
}
